/**
 * iKRDiagram Application Configuration
 */

import type { ChartImage, DropdownOption, LivePlotImageOptions, LivePlotSizeOptions, PlotSpec, PrintChartAspect, RichSummary } from '../shared';

export const APP_NAME = 'iKRDiagram';
export const APP_VERSION = '1.1.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

// Load type options
export const LOAD_TYPES: DropdownOption[] = [
  { value: '0', label: 'Triangular Load' },
  { value: '1', label: 'Triangular Pulse Load' },
  { value: '2', label: 'Rectangular Load' }
];

export interface APIPayload {
  title: string;
  W: string;
  Lo: string;
  L: string;
  Weight: string;
  KLM: string;
  Ductility: string;
  Rotation: string;
  LoadType: string;
  Pa: string;
  Ia: string;
  Ru: string;
  Xe: string;
}

export type ChartKey = 'chart_kr' | 'chart_pi';

export const PRINT_CHART_ORDER: ChartKey[] = ['chart_kr', 'chart_pi'];

export const PRINT_CHART_ASPECT = {
  chart_kr: 'square',
  chart_pi: 'square'
} satisfies Record<ChartKey, PrintChartAspect>;

export const LIVE_PLOT_CARD_MIN_HEIGHT = 'clamp(20rem, 72vw, 34rem)';

export const LIVE_PLOT_SIZE_BY_KEY = {
  chart_kr: {
    fit: 'width',
    width: '100%',
    maxWidth: '44rem',
    aspectRatio: '1 / 1.3'
  },
  chart_pi: {
    fit: 'width',
    width: '100%',
    maxWidth: '44rem',
    aspectRatio: '1 / 1.3'
  }
} satisfies Record<ChartKey, LivePlotSizeOptions>;

export const PRINT_CHART_IMAGE_OPTIONS: Record<ChartKey, LivePlotImageOptions> = {
  chart_kr: {
    width: 600,
    height: 600,
    scale: 2,
    layout: {
      font: { size: 16 },
      title: { font: { size: 28 } },
      margin: { l: 88, r: 28, t: 78, b: 114 },
      xaxis: { title: { font: { size: 18 } }, tickfont: { size: 18 } },
      yaxis: { title: { font: { size: 18 } }, tickfont: { size: 18 } },
      legend: { font: { size: 18 }, x: 0.5, xanchor: 'center', y: -0.32 }
    }
  },
  chart_pi: {
    width: 600,
    height: 600,
    scale: 2,
    layout: {
      font: { size: 16 },
      title: { font: { size: 28 } },
      margin: { l: 88, r: 28, t: 78, b: 114 },
      xaxis: { title: { font: { size: 18 } }, tickfont: { size: 18 } },
      yaxis: { title: { font: { size: 18 } }, tickfont: { size: 18 } },
      legend: { font: { size: 18 }, x: 0.5, xanchor: 'center', y: -0.32 }
    }
  }
};

export interface APIResponse {
  summary: RichSummary;
  plotData: Partial<Record<ChartKey, PlotSpec>>;
}

// Frontend state for this page after analysis. The API returns summary + plotData only;
// `charts` is generated later from mounted LivePlot components for print/save.
export type KRDiagramResultState = APIResponse & {
  charts?: Partial<Record<ChartKey, ChartImage>>;
};
